import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FileText, GraduationCap, BookOpen, ArrowRight, Play, X } from "lucide-react";
import { whatWeDo } from "../mock";

const iconMap = {
  "file-text": FileText,
  "graduation-cap": GraduationCap,
  "book-open": BookOpen,
};

const WhatWeDo = () => {
  const [playOpen, setPlayOpen] = useState(false);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        {/* Video card */}
        <div className="relative group">
          <div className="relative overflow-hidden shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1627423896085-e3e694d88e40?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="AKSUBEB School"
              className="w-full h-[460px] object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

            <button
              onClick={() => setPlayOpen(true)}
              className="absolute inset-0 flex items-center justify-center"
              aria-label="Play video"
            >
              <span className="relative">
                <span className="absolute inset-0 rounded-full bg-[#1f9d4c]/40 animate-ping" />
                <span className="relative w-20 h-20 rounded-full bg-[#1f9d4c] text-white flex items-center justify-center shadow-xl group-hover:scale-110 group-hover:bg-[#ff6b00] transition-all">
                  <Play size={32} fill="white" className="ml-1" />
                </span>
              </span>
            </button>

            <div className="absolute bottom-6 left-6 right-6 text-white">
              <p className="text-sm font-semibold uppercase tracking-widest text-[#ff6b00]">
                Play Video
              </p>
              <p className="text-xl font-bold mt-1">AKSUBEB at a glance</p>
            </div>
          </div>

          {/* Decorative thumbnails strip */}
          <div className="hidden md:flex gap-3 mt-4">
            {[
              "https://images.unsplash.com/photo-1536337005238-94b997371b40?crop=entropy&cs=srgb&fm=jpg&q=85",
              "https://images.unsplash.com/photo-1473649085228-583485e6e4d7?crop=entropy&cs=srgb&fm=jpg&q=85",
              "https://images.unsplash.com/photo-1620969910995-4bbe4eaa32c1?crop=entropy&cs=srgb&fm=jpg&q=85",
            ].map((src) => (
              <div key={src} className="flex-1 h-20 overflow-hidden">
                <img
                  src={src}
                  alt="School activity"
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Content */}
        <div>
          <p className="text-[#ff6b00] font-semibold tracking-widest text-sm uppercase mb-3">
            Our Work
          </p>

          <h2 className="text-3xl md:text-5xl font-black text-slate-900 leading-tight mb-8">
            What We Do At <span className="text-[#1f9d4c]">AKSUBEB</span>
          </h2>

          <div className="space-y-1">
            {whatWeDo.map((item) => {
              const Icon = iconMap[item.icon] || FileText;
              return (
                <div
                  key={item.id}
                  className="flex gap-5 p-5 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors group cursor-default"
                >
                  <div className="flex-shrink-0 w-14 h-14 rounded-lg bg-[#1f9d4c]/10 border border-[#1f9d4c]/20 text-[#1f9d4c] flex items-center justify-center group-hover:bg-[#ff6b00] group-hover:text-white group-hover:rotate-6 transition-all">
                    <Icon size={26} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#0a2463] mb-1.5">{item.title}</h3>
                    <p className="text-slate-600 leading-relaxed text-sm">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 mt-6 text-[#0a2463] font-bold border-b-2 border-[#0a2463] pb-1 hover:gap-3 hover:text-[#ff6b00] hover:border-[#ff6b00] transition-all"
          >
            Learn more about us <ArrowRight size={18} />
          </Link>
        </div>
      </div>

      {/* Video Modal */}
      {playOpen && (
        <div
          onClick={() => setPlayOpen(false)}
          className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-4xl aspect-video bg-black"
          >
            <button
              onClick={() => setPlayOpen(false)}
              className="absolute -top-12 right-0 text-white hover:text-[#ff6b00] transition-colors"
              aria-label="Close"
            >
              <X size={28} />
            </button>
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/JqEjEh8X4Pg?autoplay=1"
              title="AKSUBEB Promo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default WhatWeDo;
